module.exports = __webpack_public_path__ + "img/discord.3c6673de.svg";